import { createSlice, PayloadAction } from '@reduxjs/toolkit';

const initialState = {};

// This updates message state when message action is dispatched from anywhere in the application
const messageSlice = createSlice({
  name: 'message',
  initialState,
  reducers: {
    setMessage: (_: unknown, action: PayloadAction<string>) => {
      return { message: action.payload };
    },
    clearMessage: () => {
      return { message: '' };
    },
  },
});

const { reducer, actions } = messageSlice;

export const { setMessage, clearMessage } = actions;
export default reducer;
